@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid">
    <div class="row">
      <div class="col-6" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
        <h3 class="font-weight-bold">
          {{month_char}} Gross Salary Details
        </h3>
        <h6 class="font-weight-bold text-black-50">
          Work Insight
        </h6>
      </div>
      <div class="col-2 ">
        <button (click)="exportexcelsheet()" class="btn btn bg-info text-white apply"> Export Salary Sheet</button>
      </div>
      <div class="col-2">
        <button (click)="exportexcel()" class="btn btn bg-success text-white  apply"> Export Salary Full Sheet</button>
      </div>
      <div class="col-2">
        <div class="">
          <button (click)="SalaryCal()" type="submit " class="btn btn bg-primary text-white apply">
            Salary Calculations
          </button>
        </div>
      </div>

    </div>



    <!-- Exprot Sheet Table  -->
    <div class="row" style="display: none;">
      <div class=" col-12" style="text-align: center;">
        <table id="excel-table1" class="table table-bordered">
          <thead style="background: #112a5f;color: #fff;">
            <tr>
              <th>Employee Name</th>
              <td>Account #</td>
              <td>Amount(s) in PKR</td>
            </tr>
          </thead>
          <tbody>
            <!-- For Loop -->
            @for (user of usersList; track user) {
              <tr>
                <td>{{user.first_name}} {{user.last_name}}</td>
                <td>
                  <td>{{ user.ac_number === null || user.ac_number === "" ? "NOT-ADDED-YET" : user.ac_number }}</td>
                  @if (isSalaryAddedd(user)) {
                    <td>{{user.user_salary.length === 0 ? "0" :
                    user.user_salary[0].released_salary}}</td>
                  }
                </tr>
              }
            </tbody>

            <thead style="background: #112a5f;color: #fff;">
              <tr>
                <th>Total Amounts</th>
                <td><b>{{totalReleasedSalary}}</b></td>
                <td></td>
              </tr>
            </thead>
          </table>
        </div>

      </div>


      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-content rounded">
              <div class="card-body rounded-top" style="background-color: #112A5F;"
                [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                <div class="media  text-center text-white font-weight-bold font-italic">
                  <div class="col">
                    <span class="text">Salary Calculation for the month of {{month_char}} 2024</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 tblData " style="text-align: center; ">
          <table id="excel-table" class="table table-bordered">
            <thead style=" display: none; background: #112a5f;color: #fff;  "
              [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <tr>
                <td colspan="14" class="font-weight-bold font-italic display-1">Salary Calculation for the month of
                {{month_char}} 2024</td>
              </tr>
            </thead>
            <thead style="  background: #112a5f;color: #fff;" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <tr>
                <th>Employee Name</th>
                <th>Basic Salary</th>
                <th>Total Deduction</th>
                <th>Short Hours</th>
                <th>Late Check In</th>
                <th>Un Paid Leaves</th>
                <th>Absent</th>
                <th>Advance</th>
                <th>OverTime</th>
                <th>Tax</th>
                <th>Loan Amount</th>
                <th>Other Deduction</th>
                <th>Compensation</th>
                <th>Final Salary</th>
              </tr>
            </thead>
            <tbody>
              <!-- For Loop -->
              <!-- 'short_hours_amount','late_check_in_amount','unpaid_leaves_amount','absents_amount','advance_payment','overtime_amount','other_deduction','compensation_amount' -->
              @for (user of usersList; track user) {
                <tr>
                  <td style=" background: #e7ebf4; border-color: #488dd1;">{{user.first_name}} {{user.last_name}}</td>
                  <td style=" background: #e7ebf4; border-color: #488dd1;"> {{user.user_salary.length === 0 ? "0" :
                  user.user_salary[0].basic_salary}}</td>
                  <td style=" background: #fad3d0; border-color: #488dd1;">{{ getTotalDeduction(user) }}</td>
                  <td style="background: #e7ebf4; border-color: #488dd1;">{{ getShortHoursAmount(user) }}</td>
                  <td style=" background: #e7ebf4; border-color: #488dd1;">{{ getLateCheckInAmount(user) }}</td>
                  <td style="background: #e7ebf4; border-color: #488dd1;">{{ getUnpaidLeavesAmount(user) }}</td>
                  <td style="background: #e7ebf4; border-color: #488dd1;"> {{ getAbsentsAmount(user) }}</td>
                  <td style="background: #e7ebf4; border-color: #488dd1;">{{user.user_salary.length === 0 ? "0" :
                  (user.user_salary[0].advance_payment == null ? "0" : user.user_salary[0].advance_payment)}}</td>
                  <td style="background: #e7ebf4; border-color: #488dd1;">{{ getOvertimeAmount(user) }}</td>
                  <td style="background: #e7ebf4; border-color: #488dd1;">{{ getTax(user) }}</td>
                  <td style="background: #e7ebf4; border-color: #488dd1;">{{ getLoanDeduction(user) }}</td>
                  <td style="background: #e7ebf4; border-color: #488dd1;">{{ getOtherDeduction(user) }}</td>
                  <td style="background: #e7ebf4; border-color: #488dd1;">{{ getCompensationAmount(user) }}</td>
                  @if (isSalaryNotAdded(user)) {
                    <td style="background: #e7ebf4; border-color: #488dd1;"> <button
                    (click)="genrateNewSalary(user)" class="btn btn-info Genrate-Salary"> Genrate Salary </button></td>
                  }
                  @if (isSalaryAddedd(user)) {
                    <td style=" background: #e7ebf4; background: #b6f4a7; border-color: #488dd1;"
                      >{{user.user_salary.length === 0 ? "0" :
                    user.user_salary[0].released_salary}}</td>
                  }
                </tr>
              }
            </tbody>

            <thead style="background: #112a5f;color: #fff;">
              <tr style="font-size: 12px;color: black;background: #b3b6bd;">
                <th></th>
                <td>Total Salary</td>
                <td>Total Deduction</td>
                <td>Short Hours</td>

                <td>Late Check-in</td>
                <td>Un Paid Leaves</td>
                <td>Absent</td>

                <td>Advance</td>
                <td>OverTime</td>
                <td>Tax</td>

                <td>Loan Amount</td>
                <td>Other Deduction</td>
                <td>Compensation</td>

                <td><b>Released Salary</b></td>
              </tr>
              <tr>
                <th>Total Details</th>
                <td> <b>{{totalSalary}}</b></td>
                <td><b>{{totalDeduction}}</b></td>
                <td>{{total_shourtHours}}</td>
                <td>{{total_lateCheckin}}</td>
                <td>{{total_unpaidLeaves}}</td>
                <td>{{total__absents}}</td>
                <td>{{total_Advance}}</td>
                <td>{{total_Overtime}}</td>
                <td>{{total_tax}}</td>
                <td>{{loan_amount}}</td>
                <td>{{total_otherDeduction}}</td>
                <td>{{total_Compensation}}</td>
                <td><b>{{totalReleasedSalary}}</b></td>
              </tr>
            </thead>
          </table>
        </div>

      </div>
    </div>
  </main>